
//import Vue from 'vue';
import axios from 'axios';
export default {
    state: {
        getUrl() {
            const instance = axios.create({
                baseURL: 'http://10.7.210.241:3000/api'
                // baseURL: 'http://localhost:3000/'
                // baseURL : process.env.VUE_APP_CORE_API
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            return instance;
        },
        getUrl2(){
            const instance = axios.create({
                baseURL : "http://10.2.210.45:84/api/v2/Mongo2/_table",
                headers: {
                    'Content-Type':'application/json',
                    'Accept': 'application/json',
                    //'Authorization':'Bearer 3oaVaupZuuHiMOVdMMgScd1g2AkEG1BSF3aXjl8wCxo'
                    //'Access-Control-Allow-Headers': 'X-DreamFactory-API-Key',
                    'X-DreamFactory-Api-Key' : 'b0ecb6d47232ea80eefb0afb466cd6a9fca4a643bd47deba780133e50232b82d'
                  }
            });
            return instance; 
        }
    },
    getProductsMaster(productCode) {
        return this.state.getUrl().get('/products', {
                params: {
                    filter: {
                        "where": {
                            "code": {
                                "inq": productCode
                            }
                        }
                    }
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    getUnitMaster() {
        return this.state.getUrl().get('/item-unit')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    getGroups() {
        return this.state.getUrl().get('/product/hc', {
                params: {
                    filter: {
                        where: {
                            category: 'product_group'
                        }
                    }
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    getSubgroups(parentCode) {
        return this.state.getUrl().get('/product/hc', {
                params: {
                    filter: {
                        "where": {
                            "and": [{
                                "parentCode": parentCode
                            }]
                        }
                    }
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    getProductBrowse(params) {
        var where = ""
        var filters = ""
        var fields = ["code", "title_th", "seu_code", 'productcg_code', 'cost', 'price']
        var order = "title_th asc"
        if (params['cggroupsMode']) {
            where = {
                "and": [{
                    "productcg_code": params['cggroupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productcg_code": params['cggroupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        } else if (params['subgroupsMode']) {
            where = {
                "and": [{
                    "productsubgroup_code": params['subgroupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productsubgroup_code": params['subgroupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        } else if (params['groupsMode']) {
            where = {
                "and": [{
                    "productgroup_code": params['groupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productgroup_code": params['groupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        }

        if (params['keyword']) {
            where = (where) ? filters : {
                "or": [{
                    "code": {
                        "like": params['keyword']
                    }
                }, {
                    "title_th": {
                        "like": params['keyword']
                    }
                }]
            }
        }
        return this.state.getUrl().get('/products', {
                params: {
                    filter: {
                        "fields": fields,
                        "where": where,
                        "order": order,
                        "skip": params['skip'],
                        "limit": params['limit']
                    },
                    timestamp: new Date().getTime()
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    getProductBrowseUnlimit(params) {
        var where = ""
        var filters = ""
        var fields = ["code", "title_th", "seu_code", 'productcg_code', 'cost', 'price']
        var order = "title_th asc"
        if (params['cggroupsMode']) {
            where = {
                "and": [{
                    "productcg_code": params['cggroupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productcg_code": params['cggroupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        } else if (params['subgroupsMode']) {
            where = {
                "and": [{
                    "productsubgroup_code": params['subgroupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productsubgroup_code": params['subgroupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        } else if (params['groupsMode']) {
            where = {
                "and": [{
                    "productgroup_code": params['groupsMode']
                }]
            }
            filters = {
                "and": [{
                    "productgroup_code": params['groupsMode']
                }, {
                    "or": [{
                        "code": {
                            "like": params['keyword']
                        }
                    }, {
                        "title_th": {
                            "like": params['keyword']
                        }
                    }]
                }]
            }
        }

        if (params['keyword']) {
            where = (where) ? filters : {
                "or": [{
                    "code": {
                        "like": params['keyword']
                    }
                }, {
                    "title_th": {
                        "like": params['keyword']
                    }
                }]
            }
        }
        return this.state.getUrl().get('/products', {
                params: {
                    filter: {
                        "fields": fields,
                        "where": where,
                        "order": order,
                        "skip": params['skip'],
                    },
                    timestamp: new Date().getTime()
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    login(username, password) {

        // return Promise.resolve({
        //     "id": "iAcPAGDpooYKHBObtdlGPhlorKpSwqDnDICyumD5BoEK6yHSLRtCKBWfcPyPz7Yx",
        //     "ttl": 604800,
        //     "created": "2018-06-27T10:06:05.116Z",
        //     "userId": "5a9cf3c58d11b603ce53de14",
        //     "userCode": "600240",
        //     "email": "chanawut_g@dhas.com",
        //     "profile_codes": [
        //         "600240"
        //     ],
        //     "identity": {
        //         "username": "chanawut_g@dhas.com",
        //         "email": "chanawut_g@dhas.com",
        //         "id": "5a9cf3c58d11b603ce53de14",
        //         "boss_code": "520269",
        //         "code": "600240",
        //         "ctime": "2017-08-31T17:00:00.000Z",
        //         "displayname": "ชนาวุฒิ กุลภูเขียว",
        //         "employdate": "2017-09-01",
        //         "firstname": "ชนาวุฒิ",
        //         "firstname_en": "Chanawut",
        //         "lastname": "กุลภูเขียว",
        //         "lastname_en": "Gunpukyo",
        //         "mtime": "2018-03-26T14:21:13.000Z",
        //         "org_code": "620400",
        //         "pos_code": "P05039",
        //         "posg_code": "3",
        //         "posj_code": "PG5",
        //         "posl_code": "07",
        //         "profile_codes": [
        //             "600240"
        //         ]
        //     }
        // });

        return this.state.getUrl().post('/auth/signup', {
            username,
            password
        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.data.error);
        });

    },
    getDefaultPrice() {
        return this.state.getUrl().get('/pricetype')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    searchProducts(keyword) {
        let where = {"or": [{
            "code": {
                "like": keyword
            }
        }, {
            "title_th": {
                "like": keyword
            }
        }]};
        return this.state.getUrl().get('/products', {
            params: {
                filter: {
                    "fields": ["code", "title_th"],
                    "where": where,
                    "limit": 10
                },
                timestamp: new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.data.error);
        });
    },
    searchCustomers(keyword) {
        let where = {"or": [{
            "code": {
                "like": keyword
            }
        }, {
            "title_th": {
                "like": keyword
            }
        }]};
        return this.state.getUrl().get('/customers', {
            params: {
                filter: {
                    "fields": ["code", "title_th"],
                    "where": where,
                    "limit": 10
                },
                timestamp: new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.data.error);
        });
    },
    // new system
    getProductsGroup(productGroup) {

        let products = productGroup.map(x => "'" + x + "'").toString();

        return this.state.getUrl2().get('/mst_product', {
            params: {
                "fields": "code,title,title_th",
                "filter": "code in ("+products+")",
                "timestamp": new Date().getTime()
            }

        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.data.error);
        });
    },
    searchProducts2(productGroup) {

        let products = productGroup.map(x => "'" + x + "'").toString();

        return this.state.getUrl2().get('/mst_product', {
            params: {
                "fields": "code,title,title_th",
                "filter": "code in ("+products+")",
                "timestamp": new Date().getTime()
            }

        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.data.error);
        });
    }
}